import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {Translate} from 'react-redux-i18n';
import auth from '../../auth';

import Loading from '../../components/Loading/Loading';

import { updateScenario } from './ScenarioActions';
import { fetchUser } from '../User/UserActions';

function Scenario(props) {
  const { loading, scenario, user, updateScenario, fetchUser } = props;

  useEffect(() => {
    const currentUser = auth.getUser();
    fetchUser(currentUser.id);
  }, []);

  function changeField(name, e) {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    let dict = {};
    dict[name] = value;
    updateScenario(dict);
  }

  const errors = {};
  const { title, id, is_public, description, keywords, lastChange } = scenario;

  const isLoggedIn = auth.loggedIn();
  const currentUser = auth.getUser();

  const isAdmin = (user.level === 'admin' || user.level === 'master');

  return (
    <div>
      { currentUser.level }
      { loading && <Loading /> }
      <form>
        <h3><i className="fas fa-fw fa-info-circle" /> <Translate value="scenario.title"/></h3>
        <hr />
        { errors.general && <div className="alert alert-danger">{errors.general}</div> }
        <div className={`mb-3 ${errors.title && 'has-error'}`}>
          <label className="control-label" htmlFor="title"><Translate value="scenario.Title"/></label>
          <input
            type="text"
            className="form-control"
            id="title"
            value={title}
            onChange={(e) => changeField('title', e)}
            disabled={ !isAdmin}
          />
          { errors.title && this.error(errors.title) }
        </div>
        <div className={`mb-3 ${errors.id && 'has-error'}`}>
          <label className="control-label" htmlFor="id"><Translate value="scenario.Id"/></label>
          <input
            type="text"
            className="form-control"
            id="id"
            value={id}
            onChange={(e) => changeField('id', e)}
            disabled={ !isAdmin }
          />
          { errors.id && this.error(errors.id) }
        </div>
        <div className={`mb-3 ${errors.is_public && 'has-error'}`}>
          <label className="control-label" htmlFor="is_public"><Translate value="scenario.isPublic"/></label>
          <input
            type="checkbox"
            className="form-control form-check-input"
            id="is_public"
            checked={!!is_public}
            onChange={(e) => changeField('is_public', e)}
            disabled={ !isAdmin }
          />
          { errors.isPublic && this.error(errors.isPublic) }
        </div>
        {/*<div className={`mb-3 ${errors.description && 'has-error'}`}>
          <label className="control-label" htmlFor="description"><Translate value="scenario.Description"/></label>
          <input
            type="description"
            className="form-control"
            id="description"
            value={description}
            onChange={(e) => changeField('description', e)}
            disabled={ !isAdmin }
          />
          { errors.description && this.error(errors.description) }
        </div> */}
        {/*<div className={`mb-3 ${errors.keywords && 'has-error'}`}>
          <label className="control-label" htmlFor="keywords"><Translate value="scenario.Keywords"/></label>
          <input
            className="form-control"
            id="keywords"
            value={keywords}
            onChange={(e) => changeField('keywords', e)}
            disabled={ !isAdmin }
          />
          { errors.keywords && this.error(errors.keywords) }
        </div>*/}
        <div className={`mb-3 ${errors.lastChange && 'has-error'}`}>
          <label className="control-label" htmlFor="lastChange"><Translate value="scenario.LastChange"/></label>
          <div>{ lastChange }</div>
          { errors.lastChange && this.error(errors.lastChange) }
        </div>
      </form>
    </div>
  );
}

Scenario.propTypes = {
  loading: PropTypes.bool,
  scenario: PropTypes.object,
  user: PropTypes.object, // Added user to propTypes
  updateScenario: PropTypes.func.isRequired, // Added updateScenario to propTypes
  fetchUser: PropTypes.func.isRequired, // Added fetchUser to propTypes
};

const mapStateToProps = state => ({
  scenario: state.scenario.data,
  loading: state.scenario.loading,
  user: state.user.data,
  users: state.users.data
});

const mapDispatchToProps = {
  updateScenario: updateScenario,
  fetchUser: fetchUser
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Scenario);
